export const vueRoutes = Object.freeze({
  transfersConfirm: { name: 'transfers.confirm', path: 'transfers, confirm' },
  settings: { name: 'app.settings', path: '/settings' },
  verification: { name: 'app.verification', path: 'verification' },
  saleDetails: { name: 'sales.sale-details' },
  hredir: { name: 'horizon-redirect' },
  login: { name: 'login' },
  signup: { name: 'signup' },
  email: { name: 'email' },
  support: { name: 'contact-us' },
  app: { name: 'app' },

  topupBalance: { name: 'topup-balance.make' },
  portfolioTokens: { name: 'portfolio.tokens' },
  portfolioFunds: { name: 'portfolio/funds' },
  requestHistory: { name: 'portfolio.request-history' },
  widrawalRequest: { name: 'widrawalRequest.index' },
  invest: { name: 'app.invest' },
  investOverview: { name: 'invest.overview' },
  exploreTokens: { name: 'invest.explore-tokens' },
  fundDetails: { name: 'invest.fund-details' },
  starredFunds: { name: 'invest.starred' },
  trade: { name: 'app.trade' },
  createFund: { name: 'app.create-fund' },
  editFund: { name: 'app.edit-fund' },
  myFunds: { name: 'app.my-funds' },
  security: { name: 'settings.security' },
  limits: { name: 'settings.limits' },
  fundRequestHistory: { name: 'my-funds.history' }
})

export const routerScopes = Object.freeze({
  app: 'app',
  auth: 'auth',
  webshop: 'webshop',
  public: 'public'
})



// WEBPACK FOOTER //
// ./src/vue-router/const.js